import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { adminApi } from '../../services/api';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';

export default function SubscriptionSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [pkgName, setPkgName] = useState('');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }

    let attempts = 0;
    const poll = async () => {
      try {
        const r = await adminApi.get(`/admin/subscribe/status/${sessionId}`);
        if (r.data.payment_status === 'paid') {
          setStatus('success');
          setPkgName(r.data.package_name || '');
          return;
        }
        if (r.data.status === 'expired') {
          setStatus('error');
          return;
        }
        attempts++;
        if (attempts < 8) setTimeout(poll, 2000);
        else setStatus('timeout');
      } catch {
        setStatus('error');
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="subscription-success-page">
      <div className="bg-white rounded-2xl border border-slate-200 shadow-lg p-8 max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <Loader2 size={48} className="mx-auto mb-4 text-[#D44E20] animate-spin" />
            <h2 className="text-xl font-bold text-[#1A1A1A] mb-2">Verifica pagamento...</h2>
            <p className="text-sm text-slate-500">Stiamo confermando il tuo pagamento</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={32} className="text-green-600" />
            </div>
            <h2 className="text-xl font-bold text-[#1A1A1A] mb-2">Piano attivato!</h2>
            <p className="text-sm text-slate-500 mb-1">Il piano <strong>{pkgName}</strong> e ora attivo.</p>
            <p className="text-xs text-slate-400 mb-6">Valido per 30 giorni dal pagamento.</p>
            <button onClick={() => navigate('/admin')} data-testid="go-dashboard"
              className="w-full py-3 bg-[#D44E20] text-white font-bold rounded-xl hover:bg-[#B8411A] transition-colors">
              Vai alla Dashboard
            </button>
          </>
        )}
        {(status === 'error' || status === 'timeout') && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <XCircle size={32} className="text-red-500" />
            </div>
            <h2 className="text-xl font-bold text-[#1A1A1A] mb-2">Pagamento non confermato</h2>
            <p className="text-sm text-slate-500 mb-6">Il pagamento non e andato a buon fine o e scaduto. Riprova.</p>
            <button onClick={() => navigate('/admin/plans')} className="w-full py-3 bg-slate-100 text-slate-700 font-bold rounded-xl hover:bg-slate-200 transition-colors">
              Torna ai piani
            </button>
          </>
        )}
      </div>
    </div>
  );
}
